module.exports = __webpack_public_path__ + "static/group-21.c19b7ac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/stories/group-21.png
// module id = 683
// module chunks = 112904724367323